import { useContext } from "react";
import { AppContext } from "../App";
import { FaCheckCircle, FaArrowRight } from "react-icons/fa";

export default function ServiceDetailPage({ service }) {
  const appContext = useContext(AppContext);

  if (!service) return null;

  return (
    <section className="MainBodySection bg-light py-5">
      <div className="container" style={{ maxWidth: 1100 }}>
        <div className="row g-4 align-items-center mb-4">
          <div className="col-lg-6">
            <div className="text-uppercase small text-primary font-semi-bold">{service.type}</div>
            <h2 className="font-bold mt-2 mb-3">{service.title}</h2>
            <p className="text-muted fs-5 mb-3">{service.tagline}</p>
            <p className="text-muted mb-4">{service.description}</p>
            <button
              className="btn btn-primary btn-lg rounded-pill"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Request Details <FaArrowRight className="ms-2" />
            </button>
          </div>
          <div className="col-lg-6">
            <div className="rounded-4 overflow-hidden shadow-sm">
              <img
                src={service.image}
                alt={service.title}
                style={{ width: "100%", height: 320, objectFit: "cover", display: "block" }}
              />
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-lg-7">
            <div className="bg-white rounded-4 p-4 shadow-sm h-100">
              <h4 className="font-bold mb-3">What We Offer</h4>
              <p className="text-muted mb-3">{service.offeringsIntro}</p>
              <ul className="list-unstyled mb-0">
                {service.offerings.map((item) => (
                  <li key={item} className="d-flex align-items-start gap-2 mb-2">
                    <FaCheckCircle className="text-primary mt-1" />
                    <span className="text-muted">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="bg-white rounded-4 p-4 shadow-sm h-100">
              <h4 className="font-bold mb-3">Key Highlights</h4>
              <ul className="list-unstyled mb-0">
                {service.highlights.map((item) => (
                  <li key={item} className="d-flex align-items-start gap-2 mb-2">
                    <FaCheckCircle className="text-success mt-1" />
                    <span className="text-muted">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
